export const ROLE_LABELS = {
  super_admin: "Super Admin",
  guru: "Guru",
  bendahara: "Bendahara",
  siswa: "Siswa",
  pustakawan: "Pustakawan",
  operator: "Operator",
  konselor: "Konselor",
  alumni: "Alumni",
  kepala_sekolah: "Kepala Sekolah",
  wakil_kurikulum: "Wakil Kurikulum",
  wakil_kesiswaan: "Wakil Kesiswaan",
  wakil_sdm: "Wakil SDM",
  wakil_keuangan: "Wakil Keuangan",
  wakil_humas: "Wakil Humas",
  wakil_sarpras: "Wakil Sarpras",
  ketua_kelas: "Ketua Kelas",
  piket: "Guru Piket",
  komite: "Komite Sekolah",
  mahasiswa: "Mahasiswa KKN/PPL",
};

export const STAFF_ROLES = ["guru", "bendahara", "pustakawan", "operator", "konselor", "alumni",
  "kepala_sekolah", "wakil_kurikulum", "wakil_kesiswaan", "wakil_sdm", "wakil_keuangan", "wakil_humas", "wakil_sarpras", "piket", "komite"];

export const ROLE_ALIASES = { wakil_keuangan: ["bendahara"] };

const COMMON = ["/", "/alumni", "/kartu-gtk-saya", "/presensi-gtk-saya", "/siswa", "/akademik", "/jurnal", "/katalog-buku", "/akun"];
export const ROUTE_ACCESS = {
  kepala_sekolah: [...COMMON, "/gtk", "/kenaikan-kelas", "/presensi", "/presensi-harian", "/kartu", "/spp", "/transport", "/peserta-transport",
    "/buku-kas", "/laporan-transport", "/peminjaman", "/buku", "/laporan-perpustakaan", "/inventaris", "/aset", "/laporan", "/rekap-kelas", "/monitor-kelas", "/cuti-gtk"],
  wakil_kurikulum: [...COMMON, "/presensi", "/rekap-kelas", "/monitor-kelas", "/cuti-gtk", "/tugas-izin"],
  wakil_kesiswaan: [...COMMON, "/presensi-harian", "/kenaikan-kelas", "/catatan-kelas", "/kartu"],
  wakil_sdm: [...COMMON, "/gtk", "/cuti-gtk", "/verifikasi-izin", "/tugas-izin"],
  wakil_keuangan: [...COMMON, "/spp", "/transport", "/peserta-transport", "/buku-kas", "/laporan-transport", "/laporan", "/rekap-kelas", "/kartu"],
  wakil_humas: [...COMMON, "/kartu"],
  wakil_sarpras: [...COMMON, "/inventaris", "/aset", "/peminjaman", "/buku", "/laporan-perpustakaan"],
  piket: ["/", "/monitor-kelas", "/jurnal-kelas", "/akun", "/kiosk", "/tugas-izin"],
  komite: ["/", "/akun", "/spp", "/laporan", "/rekap-kelas", "/buku-kas"],
};

const BLOCKED = {};
export const setDynamicAccess = (data) => {
  const allRoutes = Object.values(data?.catalog || {}).flatMap((m) => m.routes);
  Object.entries(data?.roles || {}).forEach(([role, cfg]) => {
    const allowed = data.routes?.[role] || [];
    if ((data.grant_only || []).includes(role)) { ROUTE_ACCESS[role] = ["/", "/akun", ...allowed]; return; }
    if (cfg.enabled) BLOCKED[role] = allRoutes.filter((r) => !allowed.includes(r)); else delete BLOCKED[role];
  });
};

export const WRITE_ACCESS = {
  wakil_kesiswaan: ["/kenaikan-kelas"], wakil_sdm: ["/gtk", "/cuti-gtk", "/verifikasi-izin"], wakil_humas: ["/alumni"], wakil_sarpras: ["/inventaris", "/aset"],
  kepala_sekolah: ["/jurnal", "/karya-saya", "/cuti-gtk"], wakil_kurikulum: ["/jurnal", "/mahasiswa-kkn"], piket: ["/", "/monitor-kelas", "/jurnal-kelas", "/kiosk"],
};

export const userRoles = (user) => {
  const out = [];
  [user?.role, ...(user?.roles || [])].forEach((r) => { if (r) [r, ...(ROLE_ALIASES[r] || [])].forEach((x) => { if (!out.includes(x)) out.push(x); }); });
  return out;
};

export const hasRole = (user, ...roles) => userRoles(user).some((r) => roles.includes(r));

export const canAccess = (user, path, routeRoles) => {
  const mine = userRoles(user);
  const p = "/" + path.replace(/^\/+/, "").split("/")[0];
  if (mine.length && !mine.includes("super_admin") && mine.every((r) => (BLOCKED[r] || []).includes(p))) return false;
  if (!routeRoles || routeRoles.some((r) => mine.includes(r))) return true;
  return mine.some((r) => (ROUTE_ACCESS[r] || []).includes(p));
};

export const roleBadges = (user) => [user?.role, ...(user?.roles || []).filter((r) => r !== user?.role)].filter(Boolean);

const LEGACY_ROLES = ["super_admin", "guru", "bendahara", "siswa", "pustakawan", "operator", "konselor", "alumni", "ketua_kelas", "piket", "mahasiswa"];
export const isReadOnly = (user, path, routeRoles) => {
  const mine = userRoles(user);
  const p = "/" + path.replace(/^\/+/, "").split("/")[0];
  if (["/akun", "/kartu-gtk-saya", "/presensi-gtk-saya"].includes(p)) return false;
  if (routeRoles && routeRoles.some((r) => mine.includes(r) && LEGACY_ROLES.includes(r))) return false;
  return !mine.some((r) => (WRITE_ACCESS[r] || []).includes(p));
};
